import script from "./AdminService.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminService.vue?vue&type=script&setup=true&lang=js"

import "./AdminService.vue?vue&type=style&index=0&id=a035a504&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a035a504"]])

export default __exports__